import { assign } from 'xstate';

import { getCounterValueWithFallback } from './counter-machine.utils';

import type { CounterMachineAction } from './counter-machine.types';

// ─────────────────────────────────────────────────────────────────────────────

const storeInitialCounterValue: CounterMachineAction<{ storedValue: string | null }> = assign(
  (_, params) => ({ value: getCounterValueWithFallback(params.storedValue) }),
);

const storeCounterValue: CounterMachineAction<{ value: number }> = assign((_, params) => ({
  value: params.value,
}));

// ─────────────────────────────────────────────────────────────────────────────

export const CounterMachineActions = {
  storeInitialCounterValue,
  storeCounterValue,
};
